/**
 * Résout une couleur qui peut être soit une valeur hexadécimale soit une référence à une couleur du thème
 * @param color La couleur à résoudre (ex: "#FF0000" ou "light-color")
 * @param config La configuration contenant les couleurs du thème
 * @param defaultColor La couleur par défaut si non trouvée
 */
export const resolveColor = (
  color: string | undefined,
  config: any,
  defaultColor: string
): string => {
  if (!color) return defaultColor;

  // Si la couleur fait référence à une couleur du thème
  if (['light-color', 'medium-color', 'dark-color', 'major-color'].includes(color)) {
    return config[color] || defaultColor;
  }

  // Si c'est une valeur hexadécimale
  if (color.startsWith('#')) {
    return color;
  }

  return defaultColor;
};

/**
 * Convertit une couleur hexadécimale en rgba
 * @param hex Couleur hexadécimale (avec ou sans #)
 * @param alpha Valeur d'opacité entre 0 et 1
 */
export const hexToRgba = (hex: string, alpha: number = 1): string => {
  try {
    // Enlever le # si présent
    hex = hex.replace('#', '');
    
    // Vérifier la validité du format
    if (!/^[0-9A-Fa-f]{6}$/.test(hex)) {
      return 'rgba(255, 255, 255, 0.75)'; // Valeur par défaut
    }
    
    // Convertir en RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  } catch (error) {
    console.error('Error converting hex to rgba:', error);
    return 'rgba(255, 255, 255, 0.75)'; // Valeur par défaut en cas d'erreur
  }
};